import { ApiClientReturnType, Nullable } from '~/types';
import api from '../http-common';

// General Filters

const filtersGeneralInfo = (): ApiClientReturnType<{ assigned: number, notAssigned: number }> =>
  api.post('/filters/general/info');

const filtersGeneralIndex = () =>
  api.post('/filters/general/index');

const filtersGeneralStore = (data: GeneralStoreType): ApiClientReturnType<void> =>
  api.post('/filters/general/store', data);

const filtersGeneralEdit = (id): ApiClientReturnType<FarmerEditType> =>
  api.post(`/filters/general/${id}/edit`);

const filtersGeneralUpdate = (id: string, data: GeneralStoreType): ApiClientReturnType<void> =>
  api.post(`/filters/general/${id}/update`, data);

const filtersGeneralDelete = (id) =>
  api.post(`/filters/general/${id}/delete`);

// Geographical filters

const filtersGeographicInfo = (): ApiClientReturnType<{ assigned: number, notAssigned: number }> =>
  api.post('/filters/geographic/info');

const filtersGeographicIndex = () =>
  api.post('/filters/geographic/index');

const filtersGeographicStore = (data) =>
  api.post('/filters/geographic/store', data);

const filtersGeographicEdit = (id) =>
  api.post(`/filters/geographic/${id}/edit`);

const filtersGeographicUpdate = (id, data) =>
  api.post(`/filters/geographic/${id}/update`, data);

const filtersGeographicDelete = (id) =>
  api.post(`/filters/geographic/${id}/delete`);

// Amount filters

const filtersAmountInfo = (): ApiClientReturnType<{ assigned: number, notAssigned: number }> =>
  api.post('/filters/amount/info');

const filtersAmountIndex = () =>
  api.post('/filters/amount/index');

const filtersAmountStore = (data) =>
  api.post('/filters/amount/store', data);

const filtersAmountEdit = (id) =>
  api.post(`/filters/amount/${id}/edit`);

const filtersAmountUpdate = (id, data) =>
  api.post(`/filters/amount/${id}/update`, data);

const filtersAmountDelete = (id) =>
  api.post(`/filters/amount/${id}/delete`);

// Radius filters

const filtersRadiusInfo = (): ApiClientReturnType<{ assigned: number, notAssigned: number }> =>
  api.post('/filters/radius/info');

const filtersRadiusIndex = () =>
  api.post('/filters/radius/index');

const filtersRadiusStore = (data) =>
  api.post('/filters/radius/store', data);

const filtersRadiusEdit = (id) =>
  api.post(`/filters/radius/${id}/edit`);

const filtersRadiusUpdate = (id, data) =>
  api.post(`/filters/radius/${id}/update`, data);

const filtersRadiusDelete = (id) =>
  api.post(`/filters/radius/${id}/delete`);

const filtersNotAssignedFarmers = (type: string, data) =>
  api.post(`/filters/${type}/not-assigned-farmers/index`, data)

const filtersAssignedFarmers = (type: string, id: string, data) =>
  api.post(`/filters/${type}/${id}/assigned-farmers/index`, data)

export const IndividualFiltersService = {
  filtersGeneralInfo,
  filtersGeneralIndex,
  filtersGeneralStore,
  filtersGeneralEdit,
  filtersGeneralUpdate,
  filtersGeneralDelete,
  filtersGeographicInfo,
  filtersGeographicIndex,
  filtersGeographicStore,
  filtersGeographicEdit,
  filtersGeographicUpdate,
  filtersGeographicDelete,
  filtersAmountInfo,
  filtersAmountIndex,
  filtersAmountStore,
  filtersAmountEdit,
  filtersAmountUpdate,
  filtersAmountDelete,
  filtersRadiusInfo,
  filtersRadiusIndex,
  filtersRadiusStore,
  filtersRadiusEdit,
  filtersRadiusUpdate,
  filtersRadiusDelete,
  filtersNotAssignedFarmers,
  filtersAssignedFarmers
};

export type FarmerType = {
  id: string
  text: string
  key: string
  value?: string
  companyName?: string
}
export interface GeneralStoreType {
  name: string
  farmers: FarmerType[]
}

export interface FarmerEditType {
  id: number;
  name: string;
  farmers: Farmer[];
}

export interface Farmer {
  id: string;
  companyName: string;
  supplierNo: null | string;
  climateProgramRegistration: Nullable<boolean>;
  customFilterId: number;
  evsNumber?: Nullable<string>
  farmerId: string;
}
